import {trackEvent} from '../../../tracking/amplitude/TrackingV2';

export const triggerUserPilotNTimes = (userPilotContentId: string | null | undefined, numberOfTimes: number): void => {
	if (userPilotContentId) {
		const localStorageKey = 'userPilotTrigger' + userPilotContentId;
		const userPilotTriggerLocalStorage = localStorage.getItem(localStorageKey);
		const shownTimes = userPilotTriggerLocalStorage ? parseInt(userPilotTriggerLocalStorage.split('_')[1]) : 0;
		if (window.userpilot && shownTimes < numberOfTimes) {
			trackEvent('Userpilot Flow', 'Triggered Programmatically', {
				userPilotContentId: userPilotContentId,
				shownTimes: (shownTimes + 1).toString(10),
			});
			localStorage.setItem(localStorageKey, 'shown_' + (shownTimes + 1));
			window.userpilot.trigger(userPilotContentId);
		}
	}
};
